<template>
  <div class="modal fade modal-map-legend" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Map legend
        </div><!-- /.modal-header -->
        <div class="modal-body">

          <ul class="map-legend">
            <li>
              <img src="~assets/img/Asset 4.png" alt="" />
              Active Jobs
            </li>
            <li>
              <img src="~assets/img/Asset 10.png" alt="" />
              Job Requests
            </li>
            <li v-if="userIsNotClient">
              <img src="~assets/img/Asset 2.png" alt="" />
              Carrier Trucks
            </li>
            <li>
              <img src="~assets/img/Asset 9.png" alt="" />
              {{ userIsNotClient ? 'Other Trucks' : 'Trucks' }}
            </li>
          </ul>

        </div><!-- /.modal-body -->
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6 footer-left">
              <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
            </div>
            <div class="col-sm-6 footer-right">

            </div>
          </div><!-- /.row -->
        </div><!-- /.modal-footer -->
      </div><!-- /.modal-content -->
    </div>
  </div><!-- /.modal -->
</template>

<script>
export default {
  computed: {
    userIsNotClient () {
      return !this.$user.isClient
    }
  }
}
</script>



// WEBPACK FOOTER //
// LegendModal.vue?daac4c28